import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import { LoginPage } from '@/pages/login';
import { DashboardPage } from '@/pages/dashboard';
import { ProgramacaoPage } from '@/pages/programacao';
import { MarketingPage } from '@/pages/marketing';
import { TasksByUserPage } from '@/pages/tasks-by-user';
import { SettingsPage } from '@/pages/settings';
import { SettingsDjsPage } from '@/pages/settings-djs';
import { DevUiKitPage } from '@/pages/dev-ui-kit';
import { RootLayout } from './root';
import { RequireAuth } from '@/components/shared/require-auth';

const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  { path: '/dev/ui-kit', element: <DevUiKitPage /> },
  {
    element: (
      <RequireAuth>
        <RootLayout />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <Navigate to="/dashboard" replace /> },
      { path: '/dashboard', element: <DashboardPage /> },
      { path: '/calendar', element: <ProgramacaoPage /> },
      { path: '/marketing', element: <MarketingPage /> },
      { path: '/equipe/:slug', element: <TasksByUserPage /> },
      { path: '/settings', element: <SettingsPage /> },
      { path: '/settings/djs', element: <SettingsDjsPage /> },
    ],
  },
]);

export function AppRouter() {
  return <RouterProvider router={router} />;
}
